export default __webpack_public_path__ + "expand-79bf6afdaa235f3648d7e03482aa4949.svg";